import { render, staticRenderFns } from "./ProviderAds.vue?vue&type=template&id=2a2a9556&lang=pug&"
import script from "./ProviderAds.vue?vue&type=script&lang=js&"
export * from "./ProviderAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports